<ng-container>
  <div
    [ngClass]="cardClasses"
    (click)="handleClick()">
    <div class="hospital-info">
      <span class="hospital-label"> Facility </span>
      <span class="hospital-name">
        {{ facility?.name }}
      </span>
    </div>
    <!-- <div class="patient-id-info">
      <span class="id-label">
        Patient ID
      </span>
      <span class="id-value">
        {{ id.value }}
      </span>
    </div> -->
    <div
      *ngIf="showClickHint"
      class="click-hint">
      <mat-icon> touch_app </mat-icon>
      <span> Click to select </span>
    </div>
  </div>
</ng-container>
